module.exports = __webpack_public_path__ + "static/media/simeon v.26971bec.jpg";